import { render, staticRenderFns } from "./materTransport.vue?vue&type=template&id=d0a91262&"
import script from "./materTransport.vue?vue&type=script&lang=js&"
export * from "./materTransport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports